import restAction from "@/js/store/module/common/restAction";
const api = restAction.actions.COWORK_REST_SIMPLE_ACTION;

export default {
	/* codeValue 값 조회 */
	getCodeValueList(cdCategory, cdKey) {
		return api({}, {
			url : "/api/org/getCodeValueList",
				method : "post",
				params : {
					cdCategory: cdCategory,
					cdKey: cdKey  
				}
		}).then(resp => {
			if (!resp) { return; }
			if (resp.errorCode) { console.log('/codeValue.js getCodeValueList errorCode', resp.errorCode); }
			return resp.result;
		}).catch((err) => console.log('/codeValue.js getCodeValueList err ', err));
	}

}


// WEBPACK FOOTER //
// ./src/js/codeValue/codeValue.js